
define('text!templates/widgets/multi-account/index.ejs',[],function () { return '<a href="javascript:void(0);">\n    <i class="icon icon- icon-credit-card"></i>\n    <span>Мультивалютный счет</span>\n    <i class="icon icon-collapse pull-right"></i>\n    <i class="icon icon-expand pull-right"></i>\n</a>';});

